import { jsx as _jsx } from "react/jsx-runtime";
import { Notification } from "@jti/ui";
const NotificationBlock = ({ content }) => {
    return (_jsx("div", { children: _jsx(Notification, { children: _jsx("div", { children: content }) }) }));
};
export default NotificationBlock;
//# sourceMappingURL=Notification.js.map